document.documentElement.classList.remove('no-js');document.documentElement.classList.add('js');
/* red de seguridad: si las animaciones de aparición no disparan en 2,5 s, todo se muestra igual */
setTimeout(function(){document.querySelectorAll('.cur-root .scroll-trigger--offscreen').forEach(function(e){e.classList.remove('scroll-trigger--offscreen');});},2500);

(function(){
  'use strict';
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- aparición al hacer scroll (animations.js de la fuente) ---------- */
  function initScrollTriggers(){
    var els = document.querySelectorAll('.cur-root .scroll-trigger'); if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(en, i){
        var t = en.target;
        if (en.isIntersecting){ if (t.classList.contains('scroll-trigger--offscreen')){ t.classList.remove('scroll-trigger--offscreen'); if (t.hasAttribute('data-cascade')) t.style.setProperty('--animation-order', i); } obs.unobserve(t); }
        else { t.classList.add('scroll-trigger--offscreen'); t.classList.remove('scroll-trigger--cancel'); }
      });
    }, { rootMargin: '0px 0px -50px 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- barra con temporizador ---------- */
  function initTimers(){
    document.querySelectorAll('.timer-strip__clock').forEach(function(timer){
      var total = (parseInt(timer.dataset.hours, 10) || 0) * 3600 + (parseInt(timer.dataset.minutes, 10) || 0) * 60;
      var hEl = timer.querySelector('[data-hours]:not(.timer-strip__clock)'), mEl = timer.querySelector('[data-minutes]:not(.timer-strip__clock)'), sEl = timer.querySelector('[data-seconds]');
      if (!hEl || !mEl || !sEl) return;
      var remaining = total;
      function set(el, v){ var s = String(v).padStart(2, '0'); if (el.textContent !== s) el.textContent = s; }
      function tick(){ set(hEl, Math.floor(remaining / 3600)); set(mEl, Math.floor(remaining % 3600 / 60)); set(sEl, Math.floor(remaining % 60)); if (remaining > 0) remaining--; else remaining = total; }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- header: menú lateral y header fijo ---------- */
  function initHeader(){
    var header = document.querySelector('.el-site-header'); if (!header) return;
    var menuBtn = header.querySelector('.el-site-header__menu-nav'), overlay = header.querySelector('.el-site-header__overlay'), drawer = header.querySelector('.el-site-header__drawer'), closeBtn = header.querySelector('.el-site-header__menu-close'), body = document.body;
    function open(){ drawer && drawer.classList.add('open'); overlay && overlay.classList.add('show'); body.classList.add('no-scroll'); }
    function close(){ drawer && drawer.classList.remove('open'); overlay && overlay.classList.remove('show'); body.classList.remove('no-scroll'); }
    if (menuBtn) menuBtn.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    var h = header.offsetHeight, isSticky = false;
    window.addEventListener('scroll', function(){
      var want = window.scrollY > 40; if (want === isSticky) return; isSticky = want;
      if (want){ header.classList.add('sticky'); body.style.paddingTop = h + 'px'; }
      else { header.classList.remove('sticky'); body.style.paddingTop = ''; }
    }, { passive: true });
  }

  /* ---------- carruseles (Swiper 11.0.7, misma configuración que la fuente) ---------- */
  function initSwipers(){
    if (typeof window.Swiper !== 'function') return;
    var nav = document.querySelector('.product-offer__nav-slider'), main = document.querySelector('.product-offer__main-slider');
    if (main){
      var thumbs = nav ? new Swiper(nav, { slidesPerView: 6, spaceBetween: 7, freeMode: true, watchSlidesProgress: true, breakpoints: { 581: { slidesPerView: 5.5, spaceBetween: 16 } } }) : null;
      var cfg = { spaceBetween: 8, slidesPerView: 1.05, loop: main.querySelectorAll('.swiper-slide').length > 2, navigation: { nextEl: '.swiper-button-next-button', prevEl: '.swiper-button-prev-button' }, breakpoints: { 581: { loop: false, slidesPerView: 1 } } };
      if (thumbs) cfg.thumbs = { swiper: thumbs };
      new Swiper(main, cfg);
    }
    var t = document.querySelector('.testimonial-slider__contents');
    if (t) new Swiper(t, { loop: true, slidesPerView: 1.07, spaceBetween: 8, pagination: { el: '.testimonial-slider__contents .swiper-pagination-col', clickable: true }, navigation: { nextEl: '.swiper-button-next-testimonial', prevEl: '.swiper-button-prev-testimonial', enabled: false }, breakpoints: { 580: { slidesPerView: 2 }, 980: { spaceBetween: 20, loop: false, slidesPerView: 3, navigation: { enabled: true } } } });
  }

  /* ---------- contadores (escribe en el nodo de texto y solo si cambia) ---------- */
  function initCounters(){
    var els = document.querySelectorAll('.progress-counter__item-counter span[data-counter]'); if (!els.length) return;
    function write(el, v){ var s = v.toLocaleString(), n = el.firstChild; if (n && n.nodeType === 3 && !n.nextSibling){ if (n.nodeValue !== s) n.nodeValue = s; } else el.textContent = s; }
    function animate(el, target){ var t0 = performance.now(); (function step(now){ var p = Math.min((now - t0) / 1500, 1); write(el, Math.floor(p * target)); if (p < 1) requestAnimationFrame(step); else write(el, target); })(t0); }
    if (!('IntersectionObserver' in window)){ els.forEach(function(el){ write(el, parseInt(el.getAttribute('data-counter'), 10) || 0); }); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (!en.isIntersecting) return; var el = en.target; if (el.classList.contains('counted')) return; el.classList.add('counted'); io.unobserve(el); animate(el, parseInt(el.getAttribute('data-counter'), 10) || 0); }); }, { threshold: 0.5 });
    els.forEach(function(el){ io.observe(el); });
    setTimeout(function(){ els.forEach(function(el){ if (!el.classList.contains('counted')){ el.classList.add('counted'); write(el, parseInt(el.getAttribute('data-counter'), 10) || 0); } }); }, 8000);
  }

  /* ---------- línea de tiempo ---------- */
  function initTimeline(){
    var items = document.querySelectorAll('.progress-timeline__item'); if (!items.length) return;
    if (!('IntersectionObserver' in window)){ items.forEach(function(i){ i.classList.add('active'); }); return; }
    var lastY = window.scrollY, queue = [], busy = false;
    function next(){ if (busy || !queue.length) return; busy = true; queue.shift().classList.add('active'); setTimeout(function(){ busy = false; next(); }, 800); }
    var io = new IntersectionObserver(function(entries){
      var y = window.scrollY, down = y > lastY;
      entries.forEach(function(en){ var t = en.target; if (en.isIntersecting){ if (!t.classList.contains('active') && queue.indexOf(t) < 0){ queue.push(t); next(); } } else if (!down) t.classList.remove('active'); });
      lastY = y;
    }, { threshold: 1 });
    items.forEach(function(i){ io.observe(i); });
  }

  /* ---------- acordeones (FAQ y desplegables del bloque de compra) ---------- */
  function initAccordion(scope, itemSel, titleSel, descSel){
    var items = scope.querySelectorAll(itemSel);
    items.forEach(function(item){
      var trig = item.querySelector(titleSel), content = item.querySelector(descSel); if (!trig || !content || item.dataset.curInit) return;
      item.dataset.curInit = '1'; content.style.height = '0px'; content.style.overflow = 'hidden'; content.style.paddingBottom = '0px';
      trig.addEventListener('click', function(){
        var isOpen = item.classList.contains('is-open');
        items.forEach(function(o){ if (o === item) return; var oc = o.querySelector(descSel); o.classList.remove('is-open'); if (oc){ oc.style.height = '0px'; oc.style.paddingBottom = '0px'; } });
        if (isOpen){ item.classList.remove('is-open'); content.style.height = '0px'; content.style.paddingBottom = '0px'; }
        else { item.classList.add('is-open'); content.style.height = 'auto'; var full = content.scrollHeight + 'px'; content.style.height = '0px'; requestAnimationFrame(function(){ content.style.height = full; content.style.paddingBottom = '20px'; }); }
      });
    });
  }
  function initAccordions(){
    document.querySelectorAll('.faq-accordion').forEach(function(s){ initAccordion(s, '.faq-accordion__item', '.faq-accordion__item-title', '.faq-accordion__item-description'); });
    var po = document.querySelector('.product-offer'); if (po) initAccordion(po, '.product-offer__acc-item', '.product-offer__acc-item-title', '.product-offer__acc-item-description');
  }

  /* ---------- barra fija de compra (móvil) ---------- */
  function initSticky(){
    var sticky = document.querySelector('.product-offer__sticky'), wrap = document.querySelector('.product-offer__container'), footer = document.querySelector('.site-footer');
    if (!sticky || !('IntersectionObserver' in window)) return;
    var passed = false;
    /* si la app COD ya pinta su propia barra flotante, la barra del clon no se muestra (un solo botón fijo) */
    function appBar(){ return !!document.querySelector('#rsi_buy_now_button.rsi_floating, ._rsi-buy-now-button-floating, .es-floating-button'); }
    function set(on){ if (on && appBar()) on = false; if (sticky.classList.contains('fixed') !== on) sticky.classList.toggle('fixed', on); }
    if (wrap) new IntersectionObserver(function(e){ passed = !e[0].isIntersecting; set(passed); }, { threshold: 0 }).observe(wrap);
    if (footer) new IntersectionObserver(function(e){ if (e[0].isIntersecting) set(false); else if (passed) set(true); }, { threshold: 0 }).observe(footer);
  }

  /* ---------- selector de packs reconstruido ---------- */
  function initPacks(){
    var root = document.querySelector('[data-cur-packs]'); if (!root) return;
    var bars = root.querySelectorAll('.curb-bundles__bar[data-idx]'); if (!bars.length) return;
    var btn = document.getElementById('buy-now'), qty = document.querySelector('[data-cur-qty]');
    function select(idx){
      idx = parseInt(idx, 10) || 0;
      bars.forEach(function(b){ var on = parseInt(b.dataset.idx, 10) === idx; if (b.classList.contains('curb-bundles__bar--selected') !== on) b.classList.toggle('curb-bundles__bar--selected', on); var r = b.querySelector('input[type=radio]'); if (r && r.checked !== on) r.checked = on; });
      window.CUR_SELECTED_IDX = idx;
      var cur = root.querySelector('.curb-bundles__bar[data-idx="' + idx + '"]');
      if (cur){
        if (qty) qty.value = cur.dataset.qty || 1;
        if (btn){ var p = btn.querySelector('.btn-price'), c = btn.querySelector('.btn-compare'); if (p && p.textContent !== cur.dataset.price) p.textContent = cur.dataset.price || ''; if (c && c.textContent !== cur.dataset.compare) c.textContent = cur.dataset.compare || ''; }
      }
    }
    window.curSelectPack = select;
    bars.forEach(function(b){ b.addEventListener('click', function(){ select(b.dataset.idx); }); });
    var pre = root.querySelector('.curb-bundles__bar--selected');
    select(pre ? pre.dataset.idx : (window.CUR_SELECTED_IDX || 0));
  }

  /* ---------- botón de Releasit vestido como el de la fuente ---------- */
  var RSI_BTN = '._rsi-buy-now-button, #rsi_buy_now_button:not(.rsi_floating)';
  function initReleasitDress(){
    var host = document.getElementById('curReleasitHost'); if (!host) return;
    var root = host.closest('[data-cta-bg]') || host, d = root.dataset;
    var S = { 'background': d.ctaBg, 'background-color': d.ctaBg, 'color': d.ctaColor, 'border-radius': d.ctaRadius, 'border': '1px solid ' + d.ctaBg,
              'box-shadow': 'none', 'font-size': d.ctaSize || '16px', 'font-weight': d.ctaWeight || '700', 'font-family': d.ctaFont || 'inherit',
              'padding': d.ctaPadding || '17px 15px', 'width': '100%', 'margin': d.ctaMargin || '15px 0 0', 'text-transform': d.ctaTransform || 'none',
              'letter-spacing': '0', 'line-height': '16px', 'animation': 'none' };
    var mo = null, runs = 0, win = 0, OBS = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] };
    function dress(){
      var now = Date.now(); if (now - win > 10000){ win = now; runs = 0; }
      if (++runs > 25){ if (mo){ mo.disconnect(); mo = null; } return; }
      if (mo) mo.disconnect();
      try {
        host.querySelectorAll(RSI_BTN).forEach(function(b){
          for (var k in S){ if (S[k] && b.style.getPropertyValue(k) !== S[k]) b.style.setProperty(k, S[k], 'important'); }
          if (b.classList.contains('_rsi-buy-now-button-shaker')) b.classList.remove('_rsi-buy-now-button-shaker');
          if (b.classList.contains('rsi_animation_shake')) b.classList.remove('rsi_animation_shake');
          var svg = b.querySelector('svg'); if (svg && svg.getAttribute('fill') !== S.color) svg.setAttribute('fill', S.color);
          b.querySelectorAll('span').forEach(function(sp){ if (sp.style.getPropertyValue('color') !== S.color) sp.style.setProperty('color', S.color, 'important'); });
        });
      } catch (e) {}
      if (mo){ try { mo.observe(host, OBS); } catch (e) {} }
    }
    dress();
    if (window.MutationObserver){ mo = new MutationObserver(dress); mo.observe(host, OBS); }
    [300, 1000, 2500, 5000].forEach(function(ms){ setTimeout(dress, ms); });
    window.addEventListener('load', dress);
  }

  /* ---------- preselección de la oferta en el formulario de Releasit (por índice) ---------- */
  var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open, dialog#rsi_form_wrapper[open]', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
  var syncing = false;
  function syncReleasit(){
    if (syncing) return; syncing = true;
    var t0 = Date.now(), done = false, mo = null, clicks = 0, last = 0;
    function finish(){ done = true; syncing = false; if (mo){ mo.disconnect(); mo = null; } }
    function apply(){
      if (done) return true;
      if (!document.querySelector(RSI_MODAL)) return false;
      var offers = document.querySelectorAll(RSI_OFFER); if (!offers.length) return false;
      var el = offers[window.CUR_SELECTED_IDX | 0]; if (!el){ finish(); return true; }
      if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)){ finish(); return true; }
      var target = el.querySelector('._rsi-quantity-offers-offer') || el;
      if (clicks < 6 && Date.now() - last > 250){ clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
      return false;
    }
    if (apply()) return;
    if (window.MutationObserver){ mo = new MutationObserver(function(){ if (apply()) return; if (Date.now() - t0 > 6000) finish(); }); mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
    (function poll(){ if (done) return; if (apply()) return; if (Date.now() - t0 > 6000){ finish(); return; } setTimeout(poll, 150); })();
  }
  document.addEventListener('click', function(e){
    var h = document.getElementById('curReleasitHost'); if (!h || !e.target || !e.target.closest) return;
    var t = e.target.closest(RSI_BTN); if (t && h.contains(t)) syncReleasit();
  }, true);
  window.curOpenReleasit = function(){ var b = document.getElementById('curReleasitHost'); b = b && b.querySelector(RSI_BTN); if (!b) return false; b.click(); return true; };

  ready(function(){
    var steps = [initScrollTriggers, initTimers, initHeader, initPacks, initAccordions, initCounters, initTimeline, initSticky, initReleasitDress];
    steps.forEach(function(fn){ try { fn(); } catch (e) { if (window.console) console.warn('cur:', e); } });
    function sw(){ try { initSwipers(); } catch (e) { if (window.console) console.warn('cur swiper:', e); } }
    if (typeof window.Swiper === 'function') sw(); else window.addEventListener('load', sw);
  });
  document.addEventListener('shopify:section:load', function(ev){ var s = ev.target; if (s && s.querySelector('.faq-accordion')) s.querySelectorAll('.faq-accordion').forEach(function(f){ initAccordion(f, '.faq-accordion__item', '.faq-accordion__item-title', '.faq-accordion__item-description'); }); });
})();
